import React, { Fragment, useContext, useEffect } from "react";
import { PageTitle } from "../../layout-components";
import { useIntl, FormattedMessage } from "react-intl";
import { formatMessage } from "utils/MyFunctions";
import FormsControlsCreationBesc from "../../example-components/FormsControls/FormsControlsCreationBesc";
import FormsControlsCreationBescExport from "../../example-components/FormsControls/FormsControlsCreationBesc/export";
import UserContext from "contexts/userContext";
import PagesErrorBlocked from "../PagesErrorBlocked";
export default function Creation(props) {
  const { role, setRole, locale } = useContext(UserContext);
  const intl = useIntl();
  const [number, setNumber] = React.useState("");
  // console.log("Creation props : ", props);
  const caps = (str) => {
    return str.substring(0, 1).toUpperCase() + str.substring(1, str.length);
  };
  let icreate = props.match.url.toLowerCase().includes("creat");

  useEffect(() => {
    console.log("role is(PAGE CREATE MARITIMEM EXPORT) : ", role);
  }, [role]);
  return (
    <Fragment>
      <PageTitle
        titleHeading={
          icreate
            ? formatMessage(
                intl,
                "create_besc_maritime_import_page_title_create",
                { sense: caps(props.match.params.sens) },
              )
            : formatMessage(
                intl,
                "create_besc_maritime_import_page_title_edit",
                { number: number },
              )
        }
        titleDescription={
          icreate
            ? formatMessage(
                intl,
                "create_besc_maritime_import_page_description_create",
              )
            : formatMessage(
                intl,
                "create_besc_maritime_import_page_description_edit",
              )
        }
      />

      {!["import", "regule", "transit"].includes(props.match.params.sens) ? (
        role.blocked && icreate ? (
          <PagesErrorBlocked />
        ) : (
          <FormsControlsCreationBescExport
            bescId={props.match.params.id}
            b_mode={props.match.params.mode}
            sens={props.match.params.sens}
            mode={icreate ? "create" : "edit"}
            number={number}
            setNumber={setNumber}
          />
        )
      ) : (
        <FormsControlsCreationBesc
          bescId={props.match.params.id}
          b_mode={props.match.params.mode}
          sens={props.match.params.sens}
          mode={icreate ? "create" : "edit"}
          number={number}
          setNumber={setNumber}
        />
      )}
    </Fragment>
  );
}
